const ShoppingBag03 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}>
    <path
      fill="currentColor"
      d="M16.283 21c1.8107 0 2.7161 0 3.3844-.3618a2.9996 2.9996 0 0 0 1.3195-1.434c.305-.696.2298-1.5983.0795-3.4028l-.7-8.4c-.1294-1.5526-.1941-2.329-.5379-2.9165a3.0005 3.0005 0 0 0-1.2944-1.191C17.92 3 17.141 3 15.583 3H8.4162c-1.558 0-2.337 0-2.9511.2938a3 3 0 0 0-1.2944 1.191c-.3438.5876-.4085 1.364-.5379 2.9166l-.7 8.4c-.1504 1.8045-.2256 2.7068.0795 3.4028a2.9998 2.9998 0 0 0 1.3195 1.434C5 21 5.9054 21 7.7162 21h8.5668Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.9996 8a3.9996 3.9996 0 0 1-1.1716 2.8284 3.9996 3.9996 0 0 1-5.6568 0A3.9999 3.9999 0 0 1 7.9996 8m-4.3668-.5986-.7 8.4c-.1504 1.8045-.2256 2.7068.0795 3.4028a2.9998 2.9998 0 0 0 1.3195 1.434C5 21 5.9054 21 7.7162 21h8.5668c1.8107 0 2.7161 0 3.3844-.3618a2.9996 2.9996 0 0 0 1.3195-1.434c.305-.696.2298-1.5983.0795-3.4028l-.7-8.4c-.1294-1.5526-.1941-2.329-.5379-2.9165a3.0005 3.0005 0 0 0-1.2944-1.191C17.92 3 17.141 3 15.583 3H8.4162c-1.558 0-2.337 0-2.9511.2938a3 3 0 0 0-1.2944 1.191c-.3438.5876-.4085 1.364-.5379 2.9166Z"
    />
  </svg>
);

export default ShoppingBag03;
